import { getPersistentPlayerId } from '../api';
import config from '../config.json';
import constants from '@playcastdotio/GlobalConfig';
import { sendAnalytics } from '@playcastdotio/Analytics';
import { notifyMobileInstallReminder } from '../api/modules/notifications';
import { authStore } from '../api/stores/globalStores';

const base = constants.API_BASE_URL;

export const ping = async () => {
  const response = await fetch(base.concat('ping'));
  return await response.json();
};
// localStorage key for auto-download flag
const AUTO_DOWNLOAD_FLAG = 'playcast_auto_download';

// Set the auto-download flag in localStorage
export const setAutoDownloadFlag = (isMobile: boolean = false) => {
  try {
    const flagData = { isPavilion: true, isMobile, timestamp: Date.now() };
    console.log('[setAutoDownloadFlag] Setting flag:', flagData);
    localStorage.setItem(AUTO_DOWNLOAD_FLAG, JSON.stringify(flagData));
  } catch (e) {
    console.error('Failed to set auto-download flag:', e);
  }
};

// Check and clear the auto-download flag
export const checkAndClearAutoDownloadFlag = () => {
  try {
    const flag = localStorage.getItem(AUTO_DOWNLOAD_FLAG);
    if (flag) {
      localStorage.removeItem(AUTO_DOWNLOAD_FLAG);
      return JSON.parse(flag);
    }
  } catch (e) {
    console.error('Failed to check auto-download flag:', e);
    localStorage.removeItem(AUTO_DOWNLOAD_FLAG);
  }
  return null;
};

// Clear the auto-download flag without checking it
export const clearAutoDownloadFlag = () => {
  try {
    localStorage.removeItem(AUTO_DOWNLOAD_FLAG);
  } catch (e) {
    console.error('Failed to clear auto-download flag:', e);
  }
};

export const sendDownloadReminderEmail = async (email: string) => {
  try {
    // Send mobile install reminder notification
    notifyMobileInstallReminder(true, email);

    return { success: true };
  } catch (error) {
    console.error('Failed to send download reminder email:', error);
    return { success: false, error };
  }
};

export const download = async () => {
  console.log('Download function called');
  
  // We delay this so that Installer Downloaded and User Authenticated
  // happen in the desired order by delaying this event by 400ms
  // GA4 appears to need at least 250ms delay to not batch events
  sendAnalytics({
    name: 'Installer Downloaded',
    role: 'host',
    persistentId: getPersistentPlayerId(),
    hostAuthId: authStore.currentState.playerAuthId,
    edition: 'pavilion', // Always pavilion edition
    tier2Filters: ['machine'],
  }, {
    delay: 5000,
  });

  // Always download pavilion installer
  const downloadUrl = constants.PLAYCAST_DOWNLOAD_URL;
  console.log('Download URL:', downloadUrl);

  window.open(downloadUrl, '_self');
};
